// extracted by mini-css-extract-plugin
export default {"StatusPill":"_StatusPill--QAML8","StatusPillButton":"_StatusPillButton--VhqDx"};